import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction, usePlainList } from "@inmagik/react-crud"
import type { Document, RecordMedia } from "../types"
import { API_URL } from "../constants"

export function useDocumentsList(params: Record<string, string> = {}) {
  return useList<Document>(`${API_URL}/admin/records`, {
    query: params,
  })
}

export function useAllDocumentsList(params: Record<string, string> = {}) {
  return usePlainList<Document>(`${API_URL}/admin/records`, {
    query: params,
  })
}

export function useDocument(id: number | undefined) {
  return useDetail<Document>(`${API_URL}/admin/records`, id?.toString())
}

export function useCreateDocument() {
  return useCreate<Document>(`${API_URL}/admin/records`)
}

export function useUpdateDocument() {
  return useUpdate<Document>(`${API_URL}/admin/records`)
}

export function useDeleteDocument() {
  return useDelete(`${API_URL}/admin/records`)
}

export function usePartialUpdateDocument() {
  return usePartialUpdate<Document>(`${API_URL}/admin/records`)
}

export function useDeleteMultiDocument() {
  return useAction(`${API_URL}/admin/records/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useMediaListDocument(id: number | undefined, params: Record<string, string> = {}) {
  return usePlainList<RecordMedia>(`${API_URL}/admin/records/${id}/record-media`, {
    query: params,
  })
}

export function useCreateMediaDocument(id: number | undefined) {
  return useCreate<RecordMedia>(`${API_URL}/admin/records/${id}/create-record-media`, {
    encode: "formdata",
  })
}

export function useDeleteMediaDocument() {
  return useDelete(`${API_URL}/admin/record-media`)
}